import { render } from "./ReasonPicker.vue?vue&type=template&id=3537a95a&scoped=true"
import script from "./ReasonPicker.vue?vue&type=script&lang=js"
export * from "./ReasonPicker.vue?vue&type=script&lang=js"

import "./ReasonPicker.vue?vue&type=style&index=0&id=3537a95a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3537a95a"]])

export default __exports__